<template>
  <div v-if="suggestedfilters && suggestedfilters.filters" class="mb-3">
    <div class="mb-3">
      <span class="text-muted">{{$t('filters.suggested_filters')}}: </span>
      <b-button size="sm" v-for="filter in suggestedfilters.filters" :key="filter.value" v-on:click.prevent="changeFilter(filter.sem_action.sem_url_action)" variant="outline-primary" class="mr-1">{{filter.componentName}}: <b>{{filter.valueLabel}}</b></b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'suggestedfilters',
  data () {
    return {
      selected: null
    }
  },
  methods: {
    changeFilter: function (action) {
      this.$router.push(action);
    }
  },
  components: {
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    suggestedfilters () {
      if (this.$store.state.response &&
          this.$store.state.response.suggested_filters) {
        return this.$store.state.response.suggested_filters
      }
      return null;
    }
  }
}
</script>

<style scoped>
</style>
